// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__21SJ3","topBottomGutter":"Layout_topBottomGutter__2ebPH"};